import {
  IconButton, Collapse as ChakraCollapse, useDisclosure, Icon,
  Flex,
} from '@chakra-ui/react';
import { BsChevronDown } from 'react-icons/bs';
import './styles.css';
import { forwardRef, useImperativeHandle } from 'react';

const Collapse = forwardRef(({ title, children, ...props }, ref) => {
  const { isOpen, onToggle, onClose } = useDisclosure();

  useImperativeHandle(ref, () => ({
    close() {
      onClose();
    },
  }), []);
  return (
    <>
      <Flex justify="space-between" {...props} ref={ref}>
        {title}
        <IconButton
          size="xs"
          variant="ghost"
          onClick={onToggle}
          icon={<Icon as={BsChevronDown} className={isOpen ? 'rotate1' : 'rotate0'} />}
        />
      </Flex>
      <ChakraCollapse in={isOpen}>
        {children}
      </ChakraCollapse>
    </>
  );
});

export default Collapse;
